import { ReactNode } from "react";
import { cn } from "@/common/utils";

interface TypographyProps {
  type: "span" | "p" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  className?: string;
  children?: ReactNode;
  absolute?: boolean;
  fontSize?:
    | "text-xs"
    | "text-sm"
    | "text-base"
    | "text-lg"
    | "text-xl"
    | "text-2xl"
    | "text-3xl"
    | "text-4xl"
    | "text-5xl"
    | "text-6xl"
    | "text-7xl"
    | "text-8xl"
    | "text-9xl"
    | number;
  fontWeight?:
    | "font-thin"
    | "font-light"
    | "font-normal"
    | "font-medium"
    | "font-semibold"
    | "font-bold"
    | "font-extrabold"
    | "font-black";
  uppercase?: boolean;
  textColor?: string;
  textAlign?: "left" | "right" | "center" | "justify";
  lineHeight?: string | number;
  fontFamily?: string;
  customStyles?: string;
  textTransform?: "uppercase" | "lowercase" | "capitalize" | "none";
  m?: number;
  mx?: number;
  my?: number;
  mt?: number;
  mb?: number;
  ml?: number;
  mr?: number;
  p?: number;
  px?: number;
  py?: number;
  pt?: number;
  pb?: number;
  pl?: number;
  pr?: number;
}

export default function Typography({
  type: Tag,
  children,
  className,
  fontSize = "text-base",
  fontWeight,
  uppercase = false,
  absolute = false,
  textColor,
  textAlign,
  lineHeight,
  fontFamily,
  customStyles = "",
  textTransform,
  m,
  mx,
  my,
  mt,
  mb,
  ml,
  mr,
  p,
  px,
  py,
  pt,
  pb,
  pl,
  pr,
}: TypographyProps) {
  const styleClasses = cn(
    className,
    fontWeight,
    textColor && `text-${textColor}`,
    textTransform,
    textAlign,
    typeof lineHeight === "number" ? `leading-${lineHeight}` : lineHeight,
    fontFamily,
    { absolute: absolute, uppercase: uppercase },
    customStyles
  );

  return (
    <Tag
      className={styleClasses}
      style={{
        fontSize: `${fontSize}px`,
        margin: `${m}px`,
        marginInline: `${mx}px`,
        marginBlock: `${my}px`,
        marginTop: `${mt}px`,
        marginBottom: `${mb}px`,
        marginLeft: `${ml}px`,
        marginRight: `${mr}px`,
        padding: `${p}px`,
        paddingInline: `${px}px`,
        paddingBlock: `${py}px`,
        paddingTop: `${pt}px`,
        paddingBottom: `${pb}px`,
        paddingLeft: `${pl}px`,
        paddingRight: `${pr}px`,
      }}
    >
      {children}
    </Tag>
  );
}
